import { useQuery, useQueryClient } from "@tanstack/react-query";

import { roomsApi } from "@/lib/api";
import type { Room } from "@/types/api";

// Räume ändern sich selten — passend zum Cache-Control des Backends (5 min).
const ROOMS_STALE_TIME = 5 * 60_000;

export const roomsQueryKey = {
  all: ["rooms"] as const,
  bySlug: (slug: string) => ["rooms", slug] as const,
};

export function useRooms() {
  return useQuery({
    queryKey: roomsQueryKey.all,
    queryFn: roomsApi.list,
    staleTime: ROOMS_STALE_TIME,
  });
}

export function useRoom(slug: string | undefined) {
  const qc = useQueryClient();
  return useQuery({
    queryKey: slug ? roomsQueryKey.bySlug(slug) : ["rooms", "noop"],
    queryFn: () => roomsApi.bySlug(slug as string),
    enabled: !!slug,
    // Kommt man von der Raumliste, steht der Raum schon im Cache — kein zweiter Abruf.
    initialData: () => qc.getQueryData<Room[]>(roomsQueryKey.all)?.find((r) => r.slug === slug),
    initialDataUpdatedAt: () => qc.getQueryState(roomsQueryKey.all)?.dataUpdatedAt,
    staleTime: ROOMS_STALE_TIME,
  });
}
